/**
 * Sprint duration enum
 * Defines the duration options for sprint planning
 */
export enum SprintDuration {
  WEEKLY = "WEEKLY",
  BIWEEKLY = "BIWEEKLY",
  MONTHLY = "MONTHLY",
}
